module.exports = __webpack_public_path__ + "img/AF.133f0a34.png";